import { TronWeb } from 'tronweb';

import { Currency } from '@/constants';

export const normalizeEvmAddress = (address: string, currency: Currency) => {
  const actualRecipientAddress = [Currency.TRX, Currency.USDT_TRX].includes(currency)
    ? `0x${TronWeb.address.toHex(address).slice(2)}`
    : address;

  return actualRecipientAddress as `0x${string}`;
};
